module.exports = __webpack_public_path__ + "static/media/finish-your-plan.f9a886f0.png";